import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuditTrailItem, AuditTrailShiftType } from '@wilson/api/gateway';
import {
  AuditTrailDrawerState,
  AuditTrailShiftState,
} from '@wilson/audit-trail/states';

@Pipe({
  name: 'auditTrailPreviousShiftName',
  standalone: false,
})
export class AuditTrailPreviousShiftNamePipe implements PipeTransform {
  private readonly store = inject(Store);

  transform(
    currentAuditItem: AuditTrailItem,
    searchedType: AuditTrailShiftType = 'changedName',
  ): string {
    const currentShiftId: string = this.store.selectSnapshot(
      AuditTrailDrawerState.currentShiftId,
    );
    const lastAuditItem: AuditTrailItem | null = this.store.selectSnapshot(
      AuditTrailShiftState.findAuditItemOfSameType(
        currentShiftId,
        currentAuditItem,
        searchedType,
      ),
    );
    return lastAuditItem?.historyDelta?.name ?? 'n/a';
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [AuditTrailPreviousShiftNamePipe],
  exports: [AuditTrailPreviousShiftNamePipe],
})
export class AuditTrailPreviousShiftNamePipeModule {}
